



















import { CreateElement, VNode } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CONSTANTS } from '@/core';
import { FeedModel } from '@/type';

@Component<ImageListItem>({})
export default class ImageListItem extends Vue {
  @Prop({ type: Object, required: true })
  mediaDef!: FeedModel.MediaFromFeed;

  @Prop()
  feedId!: number;
}
